import { createContext, useContext } from "react";

/**
 * 0425: hinter der Portal-Sperre geöffnete Einstellungsseite (Export, Abo & Tarif). Der Einstellungsrahmen zeigt dann keinen
 * Einstellungsbaum und kein eigenes main (die Sperre steht im schlanken Rahmen); der Weg zurück zur Sperrseite steht darüber.
 */
export const PortalSperreContext = createContext(false);
export function usePortalSperre(): boolean {
  return useContext(PortalSperreContext);
}
